export const REDACTED_BACKEND_URL =
  import.meta.env.VITE_REDACTED_BACKEND_URL || "http://localhost:8080";
export const REDACTED_PROXY_CONTRACT =
  import.meta.env.VITE_REDACTED_PROXY_CONTRACT ||
  "thor1tsge73ydk52nul2pkr84zfqf2evxrtrsh8pnkn0kjw4z6smnctrqrd4c0c";
export const REDACTED_FEE = 15n; // 0.15%
export const REDACTED_PRIVACY_CHAIN_ID = "thorchain-1";

export const REDACTED_PROVING_WASM_URL =
  import.meta.env.VITE_REDACTED_PROVING_WASM_URL || "/redacted/redacted.wasm";
export const REDACTED_PROVING_KEY_URL =
  import.meta.env.VITE_REDACTED_PROVING_KEY_URL ||
  "/redacted/redacted_0001.zkey";

export const REDACTED_PROVING_WASM_SHA256 =
  "afd1090355a7ec24e4a8a8831d77e3367889b58cf8e27bb629337eb33524efae";
export const REDACTED_PROVING_KEY_SHA256 =
  "b609b4668b666fec6c7301eb95bf3c92be35aaa10e393f9c77bf9c8435dd816c";
